module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-03-a14aa16dc52265e03805c287bdc2347a.svg";